import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MedicalHistoryApi } from '../api/medicalhistory.api';
import { switchMap, map } from 'rxjs/operators';
import { MedicalHistoryData, MedicalHistoryMst } from '../../../interfaces/masters/medicalhistory';


@Injectable()

export class MedicalhistoryService extends MedicalHistoryData{

  constructor(private api: MedicalHistoryApi) {
    super();
  } 
  list(url: string): Observable<MedicalHistoryMst[]> { 
    return this.api.list(url);
  } 

  getById(url:string): Observable<MedicalHistoryMst>{
      return this.api.getById(url);
  }

  create(url: string, data:MedicalHistoryMst): Observable<MedicalHistoryMst[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:MedicalHistoryMst): Observable<MedicalHistoryMst> { 
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
